@if (tutorialUrl) {
  <div class="faq-video-container">
    <div class="faq-tutorial-caption">WATCH THIS VIDEO TO LEARN MORE ABOUT SABIS<sup>&reg;</sup></div>
    <iframe [src]="tutorialUrl | safeUrl" class="faq-video-player" width="100%" height="100%" frameborder="0" allowfullscreen>
      Video unavailable.
    </iframe>
  </div>
}
@if (faqs) {
  <ul class="faq-items-container">
    @for (item of faqs; track item) {
      <li>
        <div class="faq-question">{{item.Question}}</div>
        <div class="faq-answer">{{item.Answer}}</div>
      </li>
    }
  </ul>
}
